import { useState, useEffect } from 'react';

const MAX_RETRIES = 3;

export const usePollingInterceptor = (fetcher: any) => {
  const [retryCount, setRetryCount] = useState(0);
  const [isSoftErrorVisible, setIsSoftErrorVisible] = useState(false);

  useEffect(() => {
    const isDone = fetcher.state === "idle";
    const hasError = !!(fetcher.data?.serverError || fetcher.error);

    if (isDone && hasError) {
      setRetryCount((prev) => {
        const nextValue = prev + 1;
        
        if (nextValue < MAX_RETRIES) {
          setIsSoftErrorVisible(true);
        } else {
          setIsSoftErrorVisible(false);
        }
        
        return nextValue;
      });
    }

    if (isDone && fetcher.data && !fetcher.data.serverError && !fetcher.error) {
      setRetryCount(0);
      setIsSoftErrorVisible(false);
    }
  }, [fetcher.state, fetcher.data, fetcher.error]);

  if (retryCount >= MAX_RETRIES) {
    const errorMsg = fetcher.data?.message || fetcher.error?.message || "Multiplos erros ao tentar obter informações de alertas";
    throw new Error(errorMsg);
  }

  return { isSoftErrorVisible, retryCount };
};